import Main from '@/views/common/main'
// 风控
export default [
    //'风控管理'
    {
        path: '/riskManager',
        name: 'riskManager',
        meta: {
            icon: 'ios-apps',
            title: '风控管理'
        },
        component: Main,
        children: [
            // 游戏策略库配置
            {
                path: 'gameLibConf',
                name: 'riskment_gameLibConf',
                meta: { title: '游戏策略库配置' },
                component: () => import('@r/gameLibConf.vue')
            },
            {
                path: 'gameLibConf/:id',
                name: 'riskment_gameLibConf',
                meta: { title: '游戏策略库配置' },
                component: () => import('@r/gameLibConf.vue')
            },
            //智能策略库配置
            {
                path: 'intelligentLibConf',
                name: 'riskment_intelligentLibConf',
                meta: { title: '智能策略库配置' },
                component: () => import('@r/intelligentLibConf.vue')
            },
            {
                path: 'intelligentLibConf/:id',
                name: 'riskment_intelligentLibConf',
                meta: { title: '智能策略库配置' },
                component: () => import('@r/intelligentLibConf.vue')
            },
            // 风控标签库配置
            {
                path: 'riskTagLibConf',
                name: 'riskment_riskTagLibConf',
                meta: { title: '风控标签库配置' },
                component: () => import('@r/riskTagLibConf.vue')
            },

            // 玩家扶持列表
            {
                path: 'userSupport',
                name: 'riskment_userSupport',
                meta: { title: '玩家扶持列表' },
                component: () => import('@r/userSupport.vue')
            },
            // 盘口风控记录
            {
                path: 'riskRecord',
                name: 'riskment_riskRecord',
                meta: { title: '盘口风控记录' },
                component: () => import('@r/riskRecord.vue')
            },
            // 风控玩家配置
            {
                path: 'riskUser',
                name: 'riskment_riskUser',
                meta: { title: '风控玩家配置' },
                component: () => import('@r/riskUserConf.vue')
            },
            //app风控配置
            {
                path: 'riskAppConf',
                name: 'riskment_riskAppConf',
                meta: { title: 'app风控配置' },
                component: () => import('@r/riskAppConf.vue')
            },
            //个人风控buff设置
            {
                path: 'userRiskBuff',
                name: 'riskment_userRiskBuff',
                meta: { title: '个人风控buff设置' },
                component: () => import('@r/userRiskBuff.vue')
            },
            {
                path: 'gameRiskData',
                name: 'riskment_gameRiskData',
                meta: { title: '游戏对局风控详情' },
                component: () => import('@r/gameRiskData.vue')
            },
            {
                path: 'riskContorlTrend',
                name: 'riskment_riskContorlTrend',
                meta: { title: '盘口风控策略趋势' },
                component: () => import('@r/riskControlTrend.vue')
            },
            {
                path: 'handleRenData',
                name: 'riskment_handleRenData',
                meta: { title: '盘口留存数据统计' },
                component: () => import('@r/handleRenData.vue')
            },

            {
                path: 'lotteryAutoRiskCtrl',
                name: 'riskment_lotteryAutoRiskCtrl',
                meta: { title: '开奖结果-自动风控' },
                component: () => import('@r/lotteryAutoRiskCtrl.vue')
            },
            // {
            //     path: 'lotteryManualRiskCtrl',
            //     name: 'riskment_lotteryManualRiskCtrl',
            //     meta: { title: '开奖结果-手动风控' },
            //     component: () => import('@r/lotteryManualRiskCtrl.vue')
            // },
            {
                path: 'playerIPLimit',
                name: 'riskment_playerIPLimit',
                meta: { title: '玩家IP限制' },
                component: () => import('@r/playerIPLimit.vue')
            },
            {
                path: 'antiBrush',
                name: 'riskment_antiBrush',
                meta: { title: '无限代防刷' },
                component: () => import('@r/antiBrush.vue')
            },
            {
                path: 'userOnline',
                name: 'riskment_userOnline',
                meta: { title: '玩家上线监控' },
                component: () => import('@r/userOnline.vue')
            }
        ]
    }
]
// 数据报表
